(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "../../../core/ua"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("../../../core/ua"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.ua);
    global.update = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _ua) {
  "use strict";

  _exports.__esModule = true;
  _exports.batchUpdate = batchUpdate;
  _exports.update = update;

  function update(vm, unmount) {
    if (!vm.$options.computed || !vm.$options.computed.$wxInfo) {
      return;
    }

    var directives_ = vm.$options.computed.$wxInfo;
    var directives;

    if (typeof directives_ === "function") {
      directives = directives_.call(vm);
    } else {
      directives = directives_;
    }

    if ((!directives || !directives.length) && !unmount) {
      return;
    }

    return vm.$wx().sdk.compile(directives, {
      unmount: unmount
    });
  }

  var batchId = 0;
  /**
   * vue 前面一个页面的 deactive 事件发生在 后一个页面的 created 之后。
   * 假如进入一个职位详情页，职位详情页下面有到其他职位详情的链接。我们从职位1进入职位2，
   * 是没有 mounted 事件的，因为用的是同一个组件。
   */

  function batchUpdate(callback, timeout) {
    if (!_ua.inBrowser) {
      return;
    }

    timeout = timeout === undefined ? 300 : timeout;

    if (!timeout) {
      window.clearTimeout(batchId);
      batchId = 0;
      callback();
      return;
    }

    window.clearTimeout(batchId);
    batchId = window.setTimeout(function () {
      callback();
    }, timeout);
    return batchId;
  }
});
//# sourceMappingURL=update.js.map